import React, { useContext } from 'react';
import classnames from "classnames";
import { MobileContext } from "components/common";

const SettingsSectionHeader = ({
  header,
}) => {
  const { isMobile } = useContext(MobileContext);
  return (
    <h1 className={`text-xl font-title mb-4 ${isMobile ? "mt-4" : ""}`}>
      <div className={classnames('flex flex-col')}>
        <span>{header}</span>
      </div>
    </h1>
  );
};

export default SettingsSectionHeader;
